import useOrg from "@/pages/OrgManager/hooks/useOrgDetail";
import { AppDispatch, RootState } from "@/store";
import { setCurOrg } from "@/store/modules/orgReducer";
import { setCurUser, setLoginStatus } from "@/store/modules/userReducer";
import { getStorage, setStorage } from "@/utils/storage";
import { useDispatch, useSelector } from "react-redux";
import { userFetch } from "../../apis/user";
import { CommonStateEnum } from "@/types/common";
import { isEmpty, isNumber } from "lodash";
import { User, UserPermissionEnum } from "@/types/user";
import { orgFetchs } from "@/apis/org";
import { notification } from "antd";
import errorCodes from "@/apis/error";
import { useTranslation } from "react-i18next";
import { hasPermission } from "@/utils/user";

const _ = require("lodash");

type CheckStatus = () => Promise<boolean>;
type IUseCheckStatus = [{ checkStatus: CheckStatus }];

export const useCheckStatus = (): IUseCheckStatus => {
  const { t } = useTranslation();
  const storageCurOrgId = getStorage("curOrgId");
  const stateDispatch: AppDispatch = useDispatch();
  const curUser = useSelector((state: RootState) => state.userReducer.curUser);
  const curOrg = useSelector((state: RootState) => state.orgReducer.curOrg);
  let isAdmin: boolean = false;

  const [, , , { fetch }] = useOrg();

  // 1）判断用户状态是否正常 2）判断当前权限是否正常 3) 判断组织状态是否正常
  const checkStatus: CheckStatus = async () => {
    try {
      const userRes = await userFetch(curUser.id);
      isAdmin = hasPermission(userRes, [UserPermissionEnum.ADMIN]);

      if (userRes.state === CommonStateEnum.UN_ACTIVE) {
        return false;
      } else if (!isAdmin && (userRes.orgs.length === 0 || !storageCurOrgId)) {
        return false;
      } else {
        stateDispatch(setLoginStatus(true));
        if (!_.isEqual(curUser, userRes)) {
          setStorage("curUser", userRes);
          stateDispatch(setCurUser(userRes));
        }

        return await checkOrgStatus(userRes, storageCurOrgId);
      }
    } catch (error) {
      notification.warning({ placement: 'top',
        message: t("member.userFetchFail"),
        description: isNumber(error) ? errorCodes[error] : (error as String),
      });
      return false;
    }
  };

  const checkOrgStatus = async (userInfo: User, orgId: string) => {
    try {
      const orgRes = await fetch(orgId);
      if (!isEmpty(orgRes)) {
        if (!isAdmin) {
          if (!userInfo?.orgs?.some((item) => item.id === orgId)) {
            return anewSetOrgInfo(userInfo);
          }
        }
        if (isEmpty(curOrg)) stateDispatch(setCurOrg(orgRes));
        return true;
      } else {
        return anewSetOrgInfo(userInfo);
      }
    } catch (error) {
      notification.warning({ placement: 'top',
        message: t("org.orgFetchFail"),
        description: isNumber(error) ? errorCodes[error] : (error as String),
      });
      return false;
    }
  };

  const anewSetOrgInfo = async (userInfo: User) => {
    try {
      const orgs = isAdmin ? (await orgFetchs()).body : userInfo.orgs;
      if (orgs && orgs?.length > 0) {
        setStorage("curOrgId", orgs[0].id);
        stateDispatch(setCurOrg(orgs[0]));
        return true;
      } else {
        return isAdmin;
      }
    } catch (error) {
      notification.warning({ placement: 'top',
        message: t("org.orgFetchFail"),
        description: isNumber(error) ? errorCodes[error] : (error as String),
      });
      return false;
    }
  };

  return [{ checkStatus }];
};
